import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import * as S from "effect/Schema";
import { NotFound } from "./folders.js";
import { PrincipalMiddleware } from "./principal.js";
/**
 * Progress/completion tracking for one (caller, course-or-file) pair —
 * `file_course_metadata` row-shaped. `user_id` is always the caller: the
 * server never reads it from the payload, so there is no by-user variant of
 * these endpoints.
 */
export const CourseMetadata = S.Struct({
    id: S.UUID,
    type: S.Literal("online_course", "file"),
    online_course_id: S.NullOr(S.UUID),
    file_id: S.NullOr(S.UUID),
    metadata: S.NullOr(S.Unknown),
    completed: S.Boolean,
    completed_at: S.NullOr(S.String),
});
export const CourseMetadataParams = S.Struct({
    type: S.Literal("online_course", "file"),
    entity_id: S.UUID,
});
export const CreateCourseMetadataPayload = S.Struct({
    type: S.Literal("online_course", "file"),
    entity_id: S.UUID,
    metadata: S.optional(S.Unknown),
    completed: S.optional(S.Boolean),
    completed_at: S.optional(S.String),
});
export const UpdateCourseMetadataPayload = S.Struct({
    id: S.UUID,
    metadata: S.optional(S.Unknown),
    completed: S.optional(S.Boolean),
    completed_at: S.optional(S.String),
});
export const ListCourseMetadata = HttpApiEndpoint.get("listCourseMetadata", "/course-metadata")
    .setUrlParams(CourseMetadataParams)
    .addSuccess(S.Struct({ items: S.Array(CourseMetadata), total: S.Int }));
export const CreateCourseMetadata = HttpApiEndpoint.post("createCourseMetadata", "/course-metadata")
    .setPayload(CreateCourseMetadataPayload)
    .addSuccess(S.Struct({ data: CourseMetadata }));
export const UpdateCourseMetadata = HttpApiEndpoint.post("updateCourseMetadata", "/course-metadata/update")
    .setPayload(UpdateCourseMetadataPayload)
    .addSuccess(S.Struct({ data: CourseMetadata }))
    .addError(NotFound, { status: 404 });
export const courseMetadataGroup = HttpApiGroup.make("course-metadata")
    .add(ListCourseMetadata)
    .add(CreateCourseMetadata)
    .add(UpdateCourseMetadata)
    .middleware(PrincipalMiddleware);
//# sourceMappingURL=course-metadata.js.map